import type { HTMLAttributes, ReactNode } from 'react';
import {
  StyledText,
  type TextAs,
  type TextColor,
  type TextSize,
  type TextWeight,
} from './styles';

export type { TextAs, TextColor, TextSize, TextWeight };

export type UiTextProps = HTMLAttributes<HTMLElement> & {
  children?: ReactNode;
  as?: TextAs;
  size?: TextSize;
  weight?: TextWeight;
  color?: TextColor;
};

export const UiText = ({
  children,
  as = 'p',
  size = 'md',
  weight = 'default',
  color = 'default',
  ...props
}: UiTextProps) => {
  return (
    <StyledText
      as={as}
      $size={size}
      $weight={weight}
      $color={color}
      {...props}
    >
      {children}
    </StyledText>
  );
};

export default UiText;
